// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"883":"7f04f99aa66006e722f6","2895":"dce4c9e1b711f74d2445","3057":"70cd82813f81451c9806","4952":"931b548fa3d92da30642","6407":"421b99db0a2b11c1fff6"}[chunkId] + "/css/" + ({"883":"Staff","3057":"index","4952":"TestSettings","6407":"Finance"}[chunkId] || chunkId) + ".css";
};